import type { QueryKey, UseQueryOptions } from '@tanstack/react-query';
import { getFredhopperCampaigns } from './campaign.api';
import type { OptionalQueryOptions, QueryApiOptions } from '../../types/types';
import { ProductGroupFredhopperState } from '@as-react/common-types';

export const campaignQueryKeys = {
  all: () => ['campaign'] as QueryKey,
  getFredhopperCampaigns: () => [...campaignQueryKeys.all(), 'fredhopperCampaigns'] as QueryKey,
};

export const campaignQueries = (apiOptions: QueryApiOptions) => ({
  getFredhopperCampaigns: <TReturnData>(
    locale: string,
    options: OptionalQueryOptions<Array<ProductGroupFredhopperState>, TReturnData> = {}
  ): UseQueryOptions<Array<ProductGroupFredhopperState>, Error, TReturnData> => ({
    ...options,
    queryKey: campaignQueryKeys.getFredhopperCampaigns(),
    queryFn: () => getFredhopperCampaigns(apiOptions, locale),
  }),
});
